import { ApolloLink } from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';

const uri = process.env.REACT_APP_GRAPHQL_URI;
// Local phone-testing proxy (needs src/setupProxy.js + REACT_APP_USE_PROXY=true):
// const uri =
//     process.env.REACT_APP_USE_PROXY === 'true'
//         ? '/gqlproxy'
//         : process.env.REACT_APP_GRAPHQL_URI;

// Terminating link — makes the actual HTTP request to officeservice.
// `apollo-upload-client`'s typing doesn't match ApolloLink across the
// bundled TS versions; the cast is the documented workaround.
export const uploadLink = createUploadLink({
    uri,
    credentials: 'include',
    headers: { 'Apollo-Require-Preflight': 'true' },
}) as unknown as ApolloLink;
